<template>
  <div
    class="locator-location"
    :class="{
      '--selected': selected,
    }"
    @click="onClick"
    ref="location"
  >
    <!-- Name -->
    <div
      class="locator-location__name text"
      :class="{
        'm-bottom-16px': props.location?.address || props.location?.meta,
      }"
    >
      <img
        :src="selected ? markerLight : markerDark"
        alt="Ico marker dark"
        width="20"
        height="24"
      />
      <h3 v-if="props.location?.name">{{ props.location.name }}</h3>
    </div>
    <!-- Address -->
    <div
      v-if="props.location?.address"
      class="locator-location__content --address text-m"
      v-html="props.location.address"
    />
    <!-- Meta Info -->
    <div
      v-if="props.location?.meta"
      class="locator-location__content --meta text-m"
      v-html="props.location.meta"
    />
  </div>
</template>

<script>
export default {
  name: 'LocatorLocation',
}
</script>

<script setup>
import markerLight from '~/assets/img/ico/ico-marker-map-light.svg'
import markerDark from '~/assets/img/ico/ico-marker-map-dark.svg'

const emit = defineEmits(['location-click'])

const props = defineProps({
  location: Object,
  selected: Boolean,
})

const location = ref(null)

onMounted(() => {
  const links = location.value.querySelectorAll('a')
  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      window.open(link.href, '_blank')
    })
  })
})

const onClick = () => {
  emit('location-click')
}
</script>

<style lang="scss">
@import './style.scss';
</style>
